import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class NotificationService {

    public static readonly NOTICE_TYPE: string = 'notice';
    public static readonly ALERT_TYPE: string = 'alert';
    public static readonly WARNING_TYPE: string = 'warning';
    public static readonly SUCCESS_TYPE: string = 'success';
    public static readonly INFO_TYPE: string = 'info';


    public static notificationQueue$ = new Subject<any>();
    public static removedNotificationQueue$ = new Subject<any>();

    public static notify(message: string, title?: string, hiddenMessage?: string) {
        let notification = { title: title, message: message, hiddenMessage: hiddenMessage, type: this.NOTICE_TYPE, hasCloseButton: true, timeoutBeforeClose: 4000 };
        this.notificationQueue$.next(notification);
        return notification;
    }

    public static warn(message: string, title?: string, hiddenMessage?: string) {
        let notification = { title: title, message: message, hiddenMessage: hiddenMessage, type: this.WARNING_TYPE, hasCloseButton: true, timeoutBeforeClose: null };
        this.notificationQueue$.next(notification);
        return notification;
    }

    public static alert(message: string, title?: string, hiddenMessage?: string) {
        let notification = { title: title, message: message, hiddenMessage: hiddenMessage, type: this.WARNING_TYPE, hasCloseButton: true, timeoutBeforeClose: null };
        this.notificationQueue$.next(notification);
        return notification;
    }

    public static success(message: string, title?: string, hiddenMessage?: string) {
        let notification = { title: title, message: message, hiddenMessage: hiddenMessage, type: this.SUCCESS_TYPE, hasCloseButton: true, timeoutBeforeClose: 4000 };
        this.notificationQueue$.next(notification);
        return notification;
    }

    public static loading(message: string, title?: string, hiddenMessage?: string) {
        let notification = { title: title, message: message, hiddenMessage: hiddenMessage, type: this.INFO_TYPE, hasLoadingIcon: true, timeoutBeforeClose: null };
        this.notificationQueue$.next(notification);
        return notification;
    }

    public static remove(notification: any) {
        this.removedNotificationQueue$.next(notification);
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/notification/notification.service.ts